import React from "react"
import { Edit} from "react-admin"
import { usePermissions, useTranslate } from "ra-core"
import { RecordActionsTabs, SubTabProps } from "components/ui/layouts"
import ScheduleIcon from "@mui/icons-material/Schedule"
import Form from "./form"



function CompanyEdit(props: React.PropsWithChildren): JSX.Element  {
    const { permissions } = usePermissions()
    const translate = useTranslate()

    const subTabs: SubTabProps[] = [
        { label: translate("resources.schedules.name"), name: "schedules", resource: "companies", icon: <ScheduleIcon/> },
    ]

    return (
        <Edit redirect="show" mutationMode="pessimistic" actions={<RecordActionsTabs subTabs={subTabs} resourceParent="companies"/>}>
            <Form />
        </Edit>
    )
}

export default CompanyEdit
